import { MoreVert } from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';
import { FolderCard } from '~/components/FolderCard';
import type { DesignList__DesignFolder as DesignFolder } from '../DesignList.generated';
import { StudioMenu } from './StudioMenu';

export interface StudioFolderCardProps {
  designFolder: DesignFolder;
}

export const StudioFolderCard = ({ designFolder }: StudioFolderCardProps) => {
  const [searchParams] = useSearchParams();
  searchParams.set('page', '1');

  return (
    <FolderCard
      folder={designFolder}
      to={{ pathname: `../${designFolder.id}`, search: searchParams.toString() }}
      label="design"
    >
      <StudioMenu item={designFolder} Icon={MoreVert} />
    </FolderCard>
  );
};
